<template>
  <div class="wrapper small">
    <h2 class="title">Persönlichkeitstest</h2>

    <div class="wysiwyg">
      <div class="timeline">
        <a href="javascript:void(0);" @click="goToChapter(-1)"
          ><div :class="timelineClass(-1)"><span>Einleitung</span></div></a
        >
        <a href="javascript:void(0);" @click="goToChapter(0)"
          ><div :class="timelineClass(0)"><span>Motive</span></div></a
        >
        <a href="javascript:void(0);" @click="goToChapter(1)"
          ><div :class="timelineClass(1)"><span>Interessen</span></div></a
        >
        <a href="javascript:void(0);" @click="goToChapter(2)"
          ><div :class="timelineClass(2)"><span>Kompetenz</span></div></a
        >
        <a href="javascript:void(0);" @click="goToChapter(3)"
          ><div :class="timelineClass(3)"><span>Stil</span></div></a
        >
        <a href="javascript:void(0);" @click="goToChapter(4)"
          ><div :class="timelineClass(4)"><span>Engagement</span></div></a
        >
        <a href="javascript:void(0);" @click="goToChapter(5)"
          ><div :class="timelineClass(5)"><span>Angaben</span></div></a
        >
        <a href="javascript:void(0);" @click="goToChapter(6)"
          ><div :class="timelineClass(6)"><span>Profil</span></div></a
        >
      </div>

      <div class="dots">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
      <div class="slides-container">
        <transition name="slide-fade" v-on:after-leave="afterLeave">
          <div
            class="container slide"
            v-if="screens.list['welcome']"
            id="welcome-container"
          >
            <div>
              <h1>Einleitung</h1>

              <p>
                <strong
                  >Sie sind daran interessiert, mehr über sich zu erfahren, um
                  eventuell passende Möglichkeiten ehrenamtlichen Engagements zu
                  finden? Machen Sie unseren Persönlichkeitstest.</strong
                >
              </p>

              <p>
                Sie erfahren etwas über Ihre Motivlage, Ihre Interessen, Ihre
                Kompetenzen, Ihren persönlichen Stil und ihre Präferenzen im
                Blick auf Bereiche ehrenamtlichen Engagements.<br /><br />Am
                Ende des Tests wissen Sie mehr über sich. Sie erhalten ihr
                persönliches Profil und – wenn Sie mögen – Optionen
                ehrenamtlichen Engagements, die am ehesten auf Ihr Profil
                abgestimmt sind. Die Daten sind anonym und können nicht mit
                Ihnen in Verbindung gebracht werden.<br /><br />Der Test ist
                darauf angelegt, Ihre Persönlichkeit möglichst genau und
                differenziert zu erfassen. Dafür wurde eine Reihe von Fragen
                entwickelt. Gehen Sie mit uns auf eine Entdeckungsreise – Sie
                werden viel über sich erfahren.
              </p>
            </div>
            <!--div>
            <p>
              <a
                href="javascript:void();"
                @click="goNext()"
                class="btn btn-secondary float-right"
              >
                Weiter
              </a>
            </p>
          </div-->
          </div>
          <div
            class="container slide"
            v-if="screens.list['questionnaire']"
            id="section-container"
          >
            <form>
              <div>
                <div class="col-sm-12">
                  <h3 style="margin: 0 0 10px 0; padding: 0">
                    {{ currentSection.title }}
                  </h3>
                  <hr
                    style="
                      border: none;
                      border-bottom: 2px dotted #c84747;
                      margin: 0;
                      padding: 0;
                    "
                  />
                  <div>
                    <p>
                      {{ currentSection.desc }}
                    </p>
                  </div>
                  <div
                    v-for="(q, index) in currentSection.questions"
                    :key="q.text + '_' + index"
                  >
                    <question-displayer :q="q" />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div
            class="container slide"
            v-if="screens.list['submitted']"
            id="welcome-container"
          >
            <div class="row">
              <div class="col-sm-12">
                <!-- <h1>Ehrenamtstest Trier</h1>
                <p>Thank you for submission.</p> -->
                <div v-html="getReport()"></div>
              </div>
            </div>
            <div class="row navigation"></div>
          </div>
        </transition>
      </div>
      <div class="dots right">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>

      <div class="paginator" v-if="!isSubmitted">
        <a
          v-if="!isWelcomeSection"
          @click="goPrev(true)"
          href="javascript:void(0);"
          class="btn prev"
          >ZURÜCK</a
        >
        <a
          v-if="!isWelcomeSection"
          href="javascript:void(0);"
          class="btn cancel"
          @click="Cancel()"
          >ABBRUCH</a
        >
        <a
          v-if="isWelcomeSection"
          @click="goNext()"
          href="javascript:void(0);"
          class="btn next"
          >WEITER</a
        >
        <a
          v-if="!isWelcomeSection && !isLastSection"
          @click="goNext(true)"
          href="javascript:void(0);"
          class="btn next"
          >WEITER</a
        >
        <a
          v-if="!isWelcomeSection && isLastSection"
          @click="submit()"
          href="javascript:void(0);"
          class="btn next"
          >WEITER</a
        >
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import QuestionDisplayer from "@/components/QuestionDisplayer.vue";

import axios from "axios";
import questionnaire from "@/assets/js/questions.json";

export default {
  name: "Home",
  components: {
    //selectricComponent,
    QuestionDisplayer,
    //draggable
  },
  data: function () {
    return {
      apiUrl: "http://localhost/sites/samples/vuejs/ehrenamt/api/",
      token: "",
      progress: 0,
      screens: {
        list: {
          welcome: false, //welcome screen
          questionnaire: false, //sections rendering screen
          submitted: false,
        },
        upcoming: null,
        current: null,
      },
      currentIndex: -1,
      questions: questionnaire,
      answers: {},
      chaptersSaved: [],
      report: "",
      dbanswers: {},
    };
  },
  created: async function () {
    /** */
    // this.initAnswers();
    /** */
  },
  beforeMount: function () {
    var self = this;
    axios
      .get("api/init.php")
      .then(function (response) {
        // handle success
        self.token = response.data.token;
        if ("answers" in response.data) self.dbanswers = response.data.answers;
        self.initAnswers();
      })
      .catch(function (error) {
        // handle error
        console.error(error);
        self.initAnswers();
      });
  },
  mounted: function () {
    this.screens.list["welcome"] = true;
    this.screens.current = "welcome";
    $("input.selectric-input").attr("readonly", true);
    // console.log("hereee");
    // console.log($("#mobile"));

    axios
      .get("../../../../wp-admin/admin-ajax.php?action=load_menu")
      .then(function (data) {
        // console.log(data.data);
        var div = document.createElement("div");
        div.innerHTML = data.data.trim();

        // Change this to div.childNodes to support multiple top-level nodes.
        // console.log(div.firstChild);
        $("nav#main").html(div.firstChild.firstChild);
        $("#mobile").click(function () {
          // console.log("hereeeee");
          if ($("header").hasClass("open")) {
            $(this).removeClass("active");

            $("header").removeClass("open");
          } else {
            $(this).addClass("active");

            $("header").addClass("open");
          }
        });
      })
      .catch(function (error) {
        console.error(error);
      });
  },
  validations: {
    answers: {},
    groups: {
      0: ["answers.gender", "answers.age", "answers.arbeitsverhältnis"],
      1: ["answers.gender2", "answers.age2", "answers.arbeitsverhältnis2"],
    },
  },
  computed: {
    progress_style: function () {
      return "width:" + this.progress + "%";
    },
    progress_text: function () {
      return this.progress ? this.progress + "% Complete" : "";
    },
    section: function () {
      return {
        currentIndex: this.currentIndex,
        nextIndex: this.currentIndex + 1,
        prevIndex: this.currentIndex - 1,
      };
    },
    currentSection: function () {
      if (this.section.currentIndex > -1)
        return this.questions[this.section.currentIndex];
      return {};
    },
    isWelcomeSection: function () {
      return this.isWelcomeIndex(this.currentIndex); //this.currentIndex < 0;
    },
    isFirstSection: function () {
      return this.isFirstIndex(this.currentIndex); //this.currentIndex == 0;
    },
    isLastSection: function () {
      return this.isLastIndex(this.currentIndex); //!(this.currentIndex < this.totalSections - 1);
    },
    isFinalSection: function () {
      return !(this.currentIndex < this.totalSections);
    },
    isSubmitted: function () {
      return this.screens.list["submitted"];
    },
    totalSections: function () {
      return this.questions.length;
    },
    currentSectionAnswers: function () {
      let section = this.currentSection;
      let answers = this.$store.getters.getAnswers;

      let sectionAnswers = {};

      if (section?.questions)
        section.questions.forEach((q) => {
          if (q.type == "radiogrid") {
            q.answers.map(function (subq) {
              sectionAnswers[subq.variable] = answers[subq.variable];
            });
          } else sectionAnswers[q.variable] = answers[q.variable];
        });
      return sectionAnswers;
    },
    questionsByVariable: function () {
      let byVar = {};
      this.questions.forEach((section) =>
        section.questions.forEach((q) => {
          byVar[q.variable] = q;
        })
      );
      return byVar;
    },
  },
  methods: {
    isWelcomeIndex: function (sectionIndex) {
      return sectionIndex < 0;
    },
    isFirstIndex: function (sectionIndex) {
      return sectionIndex == 0;
    },
    isLastIndex: function (sectionIndex) {
      return !(sectionIndex < this.totalSections - 1);
    },
    getReport: function () {
      // return this.report;
      return this.report;
    },
    initAnswers: function () {
      var self = this;
      Object.entries(self.questionsByVariable).forEach((entry) => {
        const [key, value] = entry;
        if (value.type == "order") {
          self.$store.commit("updateAnswer", {
            key: key,
            value: self.dbanswers[key] ? self.dbanswers[key] : [],
          });
        } else if (value.type == "select" || value.type == "radio") {
          const result = value.answers.filter(function (a) {
            return a.default;
          });

          if (self.dbanswers[key])
            self.$store.commit("updateAnswer", {
              key: key,
              value: self.dbanswers[key],
            });
          else if (result.length > 0)
            self.$store.commit("updateAnswer", {
              key: key,
              value: result[0].value,
            });
          else self.$store.commit("updateAnswer", { key: key, value: null });
        } else if (value.type == "radiogrid") {
          value.answers.map(function (q) {
            self.$store.commit("updateAnswer", {
              key: q.variable,
              value: self.dbanswers[q.variable]
                ? self.dbanswers[q.variable]
                : value.default,
            });
          });
        } else
          self.$store.commit("updateAnswer", {
            key: key,
            value: self.dbanswers[key] ? self.dbanswers[key] : null,
          });
      });
    },
    scrollToTop: function () {
      //console.log("scrollToTop");
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    save: function () {
      var app = this;
      return new Promise(function (resolve, reject) {
        const config = {
          headers: { Authorization: `Bearer ${app.token}` },
        };

        var data = { answers: app.currentSectionAnswers };
        app.chaptersSaved.push(app.currentIndex);

        axios
          .post("api/qsave.php", data, config)
          .then(function () {
            resolve();
          })
          .catch(function (error) {
            console.error("Error saving");
            console.error(error.message);
            reject();
          });
      });
    },
    goNext: function (save = false) {
      if (save) {
        this.save()
          .then(function () {})
          .catch(function () {
            alert("Unable to save!");
          });
      }

      if (!this.isLastSection) {
        this.currentIndex += 1;
        if (this.currentIndex > -1 && this.screens.current == "welcome")
          this.goTo("questionnaire");
        this.updateProgress(this.currentIndex);
        this.scrollToTop();
      }
    },
    goPrev: function (save = false) {
      if (save)
        this.save()
          .then(function () {})
          .catch(function () {
            alert("Unable to save!");
          });

      if (this.currentIndex >= 0) {
        this.currentIndex -= 1;
        if (this.currentIndex < 0 && this.screens.current == "questionnaire")
          this.goTo("welcome");
        this.updateProgress(this.currentIndex);
        this.scrollToTop();
      }
    },
    Cancel: function () {
      location.reload();
    },
    submit: function () {
      this.save();
      this.currentIndex += 1;
      this.goTo("submitted");
      var self = this;
      self.report = "";
      axios
        // .get("http://localhost:8888/xiqit/weil-mehr-geht_2/wp-admin/admin-ajax.php?action=load_report")
        .get("../../../../wp-admin/admin-ajax.php?action=load_report")
        .then(function (data) {
          if (data.data.length > 1) {
            var div = document.createElement("div");
            div.innerHTML = data.data.trim();
            // console.log(div.firstChild.innerHTML);
            // self.report = div.firstChild.innerHTML;
            self.report = div.innerHTML.substring(0,div.innerHTML.length - 1);
          } else self.report = "Report unavailable";
        })
        .catch(function (error) {
          // this.report = ''
          self.report = "Error fetching report";
          console.error("Error fetching report");
          console.error(error);
        });
      this.scrollToTop();
    },
    goTo: function (screen) {
      if (typeof this.screens.list[screen] == "undefined") {
        this.screens.list[this.screens.current] = false;
        return;
      }
      this.screens.list[this.screens.current] = false;
      this.screens.upcoming = screen;
      this.updateProgress(screen);
    },
    goToChapter: function (chapter, save = true) {
      //let tmp = this.currentIndex
      //this.currentIndex = chapter;
      if (save && !(this.isWelcomeSection || this.isSubmitted)) {
        //this.currentIndex = tmp;
        this.save()
          .then(function () {})
          .catch(function () {
            alert("Unable to save!");
          });
      }

      this.currentIndex = chapter;

      if (!this.isWelcomeSection && this.isFinalSection) this.submit();
      //this.goTo("submitted");
      else {
        if (
          this.currentIndex < 0 &&
          (this.screens.current == "questionnaire" ||
            this.screens.current == "submitted")
        )
          this.goTo("welcome");
        else if (
          this.currentIndex > -1 &&
          (this.screens.current == "welcome" ||
            this.screens.current == "submitted")
        )
          this.goTo("questionnaire");
      }

      //this.updateProgress(this.currentIndex);
    },
    afterLeave: function () {
      //el is passed as param
      /** */
      //if(this.screens.upcoming == this.screens.current) return

      this.screens.list[this.screens.upcoming] = true;
      this.screens.current = this.screens.upcoming;

      /** */
    },
    updateProgress: function (screen) {
      /** */
      if (screen == "welcome") this.progress = 0;
      else if (screen == "questionnaire") this.progress = 0;
      else
        this.progress =
          (parseInt(this.section.currentIndex) / this.totalSections) * 100;
      /** */
    },
    validate: function () {},
    isSelected: function (q) {
      if (q.default && q.default === true) return true;
      else return false;
    },
    timelineClass: function (step) {
      if (step == this.section.currentIndex) return "step selected";
      else if (step < 0 || this.chaptersSaved.indexOf(step) != -1)
        return "step filled";
      else return "step";
    },
  },
};
</script>
